/* Mobile card slider: swipeable row with dots. Used by sections that opt in with data-mg-slider. */
(() => {
  const init = (root) => {
    root.querySelectorAll('[data-mg-slider]').forEach((track) => {
      if (track.dataset.mgSliderReady) return;
      track.dataset.mgSliderReady = '1';
      const dots = track.parentElement.querySelector('[data-mg-slider-dots]');
      if (!dots) return;
      const buttons = [...dots.querySelectorAll('button')];
      const cards = [...track.children];
      const setActive = () => {
        const tr = track.getBoundingClientRect();
        const mid = tr.left + track.clientWidth / 2;
        let best = 0;
        let dist = Infinity;
        cards.forEach((c, i) => {
          const cr = c.getBoundingClientRect();
          const d = Math.abs(cr.left + cr.width / 2 - mid);
          if (d < dist) { dist = d; best = i; }
        });
        // at the very end the last card is active even if it cannot reach the centre
        if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) best = cards.length - 1;
        buttons.forEach((b, i) => {
          b.setAttribute('aria-current', i === best ? 'true' : 'false');
        });
      };
      let raf = 0;
      track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(setActive); }, { passive: true });
      buttons.forEach((b, i) => b.addEventListener('click', () => {
        const c = cards[i];
        if (!c) return;
        const cr = c.getBoundingClientRect();
        const tr = track.getBoundingClientRect();
        track.scrollTo({ left: track.scrollLeft + (cr.left - tr.left) - (track.clientWidth - cr.width) / 2, behavior: 'smooth' });
      }));
      setActive();
    });
  };
  const start = () => init(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
